import { Deserializable } from '../_common/deserializable';

export class TxKwMsg  implements Deserializable{
    id: number;
    kid: number;
    lang: string;
    subscribeSuccessMsg: string;
    subscribeAlreadyMsg: string;
    subscribeFailedMsg: string;
    subscribeChargeSuccessMsg: string;
    subscribeChargeSuccessUrl: string;
    subscribeLowBalanceMsg: string;
    renewalReminderMsg: string;
    renewalSuccessMsg: string;
    renewalSuccessUrl: string;
    renewalLowBalanceMsg: string;
    unsubscribeSuccessMsg: string;
    unsubscribeAlreadyMsg: string;
    mtContent: string;
    mtContentUrl: string;
    createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
